import { Component, Input, OnInit } from '@angular/core';
import { TypeBagsWeight } from '@app/enums';
/**
 * Componente que muestra los detalles del equipaje de mano.
 * 
 * Este componente permite visualizar el peso y la cantidad de piezas de equipaje de mano 
 * seleccionadas por el usuario.
 */
@Component({
    selector: 'am-bag-detail-carryon',
    templateUrl: './am-bag-detail-carryon.component.html',
    styleUrls: ['./am-bag-detail-carryon.component.scss'],
    standalone: false
})
export class AmBagDetailCarryonComponent implements OnInit {

   /**
   * Peso del equipaje de mano seleccionado.
   * Valor por defecto: 10KG.
   */
   @Input() bagWeight: TypeBagsWeight = TypeBagsWeight._10KG;

   /**
    * Cantidad de piezas de equipaje de mano.
    * Valor por defecto: 1.
    */
   @Input() count: number = 1;
 
   /**
    * Referencia al enum TypeBagsWeight para utilizarlo en la plantilla.
    */
   BagsWeight = TypeBagsWeight;
  constructor() { }

  ngOnInit(): void {
  }

}
